export default __webpack_public_path__ + "static/media/team_desktop.f6a409dc.jpg";